"use client";

import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      richColors
      expand
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--error-bg": "hsl(0, 86%, 97%)",
          "--error-text": "hsl(0, 74%, 42%)",
          "--error-border": "hsl(0, 90%, 90%)",
          "--success-bg": "hsl(142, 76%, 96%)",
          "--success-text": "hsl(142, 72%, 28%)",
          "--success-border": "hsl(142, 76%, 88%)",
          "--warning-bg": "hsl(48, 100%, 96%)",
          "--warning-text": "hsl(31, 92%, 35%)",
          "--warning-border": "hsl(45, 95%, 86%)",
          "--info-bg": "hsl(210, 100%, 97%)",
          "--info-text": "hsl(217, 91%, 40%)",
          "--info-border": "hsl(214, 95%, 90%)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
